var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "settings-page" },
    [
      !_vm.loader
        ? [
            _c(
              "div",
              { staticClass: "settings-page__header" },
              [
                _c("h1", { staticClass: "settings-page__title" }, [
                  _vm._v(_vm._s(_vm.$l10n.__("Réglages")))
                ]),
                _vm._v(" "),
                _c("HeadingTabs", {
                  attrs: {
                    tabs: [
                      {
                        name: "settings.home.general",
                        label: _vm.$l10n.__("Général")
                      },
                      {
                        name: "settings.home.internal",
                        label: _vm.$l10n.__("Module Sellsy")
                      },
                      {
                        name: "settings.home.external",
                        label: _vm.$l10n.__("Module Externe")
                      }
                    ],
                    type: "vuerouter",
                    activeTab: _vm.state
                  },
                  on: {
                    "tab-clicked": function($event) {
                      return _vm.$router.push({
                        name: "settings.home." + $event
                      })
                    }
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { class: _vm.layoutClasses }, [
              _vm.showSidebar
                ? _c(
                    "aside",
                    { staticClass: "settings-page__sidebar" },
                    [
                      _c(
                        "h3",
                        {
                          staticClass:
                            "settings-page__sidebar-title typographies-heading-h3"
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.$t.__("settings.conformitySidebar.title")
                              ) +
                              "\n                "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "settings-page__sidebar-introduction typographies-paragraph-medium-regular"
                        },
                        [
                          _c("img", {
                            attrs: {
                              src:
                                "/ressources/logged/img/illustrations/invoicing-signature-blue.svg",
                              alt: _vm.$t.__(
                                "eInvoicing.conformityCheckListHeader.title"
                              )
                            }
                          }),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm.$t.__(
                                    "settings.conformitySidebar.description"
                                  )
                                ) +
                                "\n                    "
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c("CheckList", {
                        staticClass: "settings-page__sidebar-checklist",
                        attrs: {
                          items: _vm.checkListItems,
                          loading: _vm.isLoadingChecklist
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "settings-page__content" },
                [_c("router-view")],
                1
              )
            ])
          ]
        : _c(
            "div",
            { staticClass: "prelative" },
            [_c("preloader", { attrs: { display: _vm.loader } })],
            1
          )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }